var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCareCredit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 28,
    viewBox: "0 0 37 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 10.5V3.89286C1.25 2.43326 2.43325 1.25 3.89286 1.25H32.9643C34.4239 1.25 35.6071 2.43326 35.6071 3.89286V10.5H1.25Z",
    fill: "#CDD3FE",
    stroke: "#1429B8",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6071 10.5V23.7143C35.6071 25.1739 34.4239 26.3571 32.9643 26.3571H3.89286C2.43325 26.3571 1.25 25.1739 1.25 23.7143V10.5H35.6071Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9297 20.8047H29.9297M35.6071 23.7143V10.5L1.25 10.5V23.7143C1.25 25.1739 2.43325 26.3571 3.89286 26.3571H32.9643C34.4239 26.3571 35.6071 25.1739 35.6071 23.7143Z",
    stroke: "#1429B8",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareCredit);
export default __webpack_public_path__ + "static/media/care-credit.215aee9ac845210d41c97e8a12503152.svg";
export { ForwardRef as ReactComponent };